import { VhcRecordBaseElements } from './components/base-elements';
import { DecimalInput } from './decimal-input';
import { VhcRecordDescription } from './description';
import { useVhcStore } from 'features/vhc/model/vhc-store';
import { Col, Form, Row } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';

export const VhcRecordWheelTyreForm = () => {
  const { control } = useFormContext();
  const { recordModalData } = useVhcStore();
  const { isReport } = recordModalData || {};

  return (
    <div className="ok-form">
      <Row>
        <Col md={12} className="d-flex flex-column gap-6">
          <VhcRecordDescription />
          <>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">Make</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">Make</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="make"
                    control={control}
                    render={({ field }) => (
                      <Form.Control
                        disabled={isReport}
                        className="form-control-solid"
                        {...field}
                        value={field.value || ''}
                      />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">Model</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">Model</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="model"
                    control={control}
                    render={({ field }) => (
                      <Form.Control
                        disabled={isReport}
                        className="form-control-solid"
                        {...field}
                        value={field.value || ''}
                      />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">Size</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">Size</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="size"
                    control={control}
                    render={({ field }) => (
                      <Form.Control
                        disabled={isReport}
                        className="form-control-solid"
                        {...field}
                        value={field.value || ''}
                      />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">DOT Code</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">DOT Code</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="dotCode"
                    control={control}
                    render={({ field }) => (
                      <Form.Control
                        disabled={isReport}
                        className="form-control-solid"
                        {...field}
                        value={field.value || ''}
                      />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">Tyre Tread Reading Inner</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">Tyre Tread Reading Inner</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="readingInner"
                    control={control}
                    render={({ field }) => (
                      <DecimalInput value={field.value} onChange={field.onChange} disabled={isReport} />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">Tyre Tread Reading Middle</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">Tyre Tread Reading Middle</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="readingMiddle"
                    control={control}
                    render={({ field }) => (
                      <DecimalInput value={field.value} onChange={field.onChange} disabled={isReport} />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block d-lg-none fs-7 mb-2">Tyre Tread Reading Outer</Form.Label>
              <div className="row align-items-center">
                <Form.Label className="col-lg-3 d-none d-lg-block fs-7">Tyre Tread Reading Outer</Form.Label>
                <div className="col-12 col-lg-9">
                  <Controller
                    name="readingOuter"
                    control={control}
                    render={({ field }) => (
                      <DecimalInput value={field.value} onChange={field.onChange} disabled={isReport} />
                    )}
                  />
                </div>
              </div>
            </Form.Group>
          </>

          {<VhcRecordBaseElements />}
        </Col>
      </Row>
    </div>
  );
};
